<div class="checkout-page">

  <div class="mobile-checkout-header">

  <button
    class="back-btn"
    routerLink="/">

    <i class="fa-solid fa-arrow-left"></i>

  </button>

  <div class="mobile-title">

    <h3>{{ items.length }} {{ t('items') }}</h3>

    <span>{{ t('shippingFee') }} : {{ 60 | bnNumber:'৳' }}</span>

  </div>

</div>

  <!-- PAGE HEADER -->

  <div class="checkout-header">

    <div>

      <p class="mini-title">
        {{ t('secureCheckout') }}
      </p>

      <h1 class="page-title">

        <i class="fa-solid fa-bag-shopping"></i>

        {{ t('checkout') }}

      </h1>

      <span class="sub-title">
        {{ t('completeOrderPayment') }}
      </span>

    </div>

    <!-- TOP SUMMARY -->

    <div class="top-summary">

      <div class="top-box">

        <span>{{ t('items') }}</span>

        <h3>
          {{ items.length }}
        </h3>

      </div>

      <div class="top-box">

        <span>{{ t('total') }}</span>

        <h3>
          {{ (total + 60) | bnNumber:'৳ ' }}
        </h3>

      </div>

    </div>

  </div>

  <!-- GRID -->

  <div class="checkout-grid">

    <!-- LEFT -->

    <div class="checkout-card">

      <!-- SHIPPING -->

      <div class="section-header">

        <i class="fa-solid fa-location-dot"></i>

        <h2>
          {{ t('shippingDetails') }}
        </h2>

      </div>

      <!-- NAME -->

      <div class="form-group">

        <label>{{ t('fullName') }}</label>

        <input
          [(ngModel)]="name"
          [placeholder]="t('enterFullName')"
        />

      </div>

      <!-- PHONE -->

      <div class="form-group">

        <label>{{ t('phoneNumber') }}</label>

        <input
          [(ngModel)]="phone"
          [placeholder]="t('enterPhoneNumber')"
        />

      </div>

      <!-- ADDRESS -->

      <div class="form-group">

        <label>{{ t('deliveryAddress') }}</label>

        <textarea
          [(ngModel)]="address"
          [placeholder]="t('writeCompleteAddress')">
        </textarea>

      </div>

      <!-- PAID AMOUNT -->

<div class="form-group">

  <label>{{ t('paidAmount') }}</label>

  <input
    type="number"
    [(ngModel)]="paidAmount"
    [placeholder]="t('enterPaidAmount')"
  />

</div>

      <!-- PAYMENT -->

      <div class="payment-section">

        <div class="section-header">

          <i class="fa-solid fa-credit-card"></i>

          <h2>
            {{ t('paymentMethod') }}
          </h2>

        </div>

        <div class="payment-options">

          <!-- BKASH -->

          <label class="payment-card">

            <input
              type="radio"
              name="payment"
              value="BKASH"
              [(ngModel)]="payment"
            >

            <img
              src="https://download.logo.wine/logo/BKash/BKash-Logo.wine.png"
              alt="bKash"
            >

            <span>bKash</span>

          </label>

          <!-- NAGAD -->

          <label class="payment-card">

            <input
              type="radio"
              name="payment"
              value="NAGAD"
              [(ngModel)]="payment"
            >

            <img
              src="https://download.logo.wine/logo/Nagad/Nagad-Logo.wine.png"
              alt="Nagad"
            >

            <span>Nagad</span>

          </label>

          <!-- CARD (VISA / MASTERCARD) -->

          <label class="payment-card">

            <input
              type="radio"
              name="payment"
              value="CARD"
              [(ngModel)]="payment"
            >

            <img
              src="https://cdn-icons-png.flaticon.com/512/196/196578.png"
              alt="Card"
            >

            <span>{{ t('cardPayment') }}</span>

          </label>

          <!-- COD -->

          <label class="payment-card">

            <input
              type="radio"
              name="payment"
              value="COD"
              [(ngModel)]="payment"
            >

            <img
              src="https://cdn-icons-png.flaticon.com/512/2489/2489756.png"
              alt="Cash On Delivery"
            >

            <span>{{ t('cashOnDelivery') }}</span>

          </label>

        </div>

        <!-- ONLINE পেমেন্ট মেথড সিলেক্ট করা থাকলে ছোট নোট, যাতে ইউজার
             বুঝতে পারে "Place Order"-এ ক্লিক করলে bKash/Nagad/Card-এর
             পেমেন্ট পেজে নিয়ে যাওয়া হবে -->
        <p class="payment-redirect-note" *ngIf="payment !== 'COD'">
          <i class="fa-solid fa-circle-info"></i>
          {{ t('onlinePaymentRedirectNote') }}
        </p>

      </div>

      <!-- MAP -->

      <div class="map-section">

        <div class="section-header">

          <i class="fa-solid fa-map-location-dot"></i>

          <h2>
            {{ t('deliveryLocation') }}
          </h2>

        </div>

        <!-- SEARCH + CURRENT LOCATION -->

        <div class="map-toolbar">

          <div class="map-search-box">

            <i class="fa-solid fa-magnifying-glass"></i>

            <input
              type="text"
              [(ngModel)]="searchQuery"
              [placeholder]="t('searchLocationPlaceholder')"
              (input)="onSearchLocation()"
            />

            <div
              class="search-results"
              *ngIf="searchResults.length"
            >

              <div
                class="search-result-item"
                *ngFor="let r of searchResults"
                (click)="selectSearchResult(r)"
              >
                {{ r.label }}
              </div>

            </div>

          </div>

          <button
            type="button"
            class="use-location-btn"
            (click)="useMyLocation()"
            [disabled]="locating"
          >

            <i class="fa-solid fa-location-crosshairs"></i>

            <span *ngIf="!locating">{{ t('useMyLocation') }}</span>
            <span *ngIf="locating">{{ t('locatingYou') }}</span>

          </button>

        </div>

        <div
          #mapContainer
          class="delivery-map"
        ></div>

        <p class="map-hint" *ngIf="!latitude">
          {{ t('tapMapToSelect') }}
        </p>

        <p class="map-hint map-hint-selected" *ngIf="latitude">
          <i class="fa-solid fa-circle-check"></i>
          {{ t('locationSelected') }}: {{ locationLabel || (latitude + ', ' + longitude) }}
        </p>

      </div>

      <!-- BUTTON -->

      <button
        class="order-btn"
        (click)="placeOrder()"
        [disabled]="placingOrder"
      >

        <i class="fa-solid fa-check" *ngIf="!placingOrder"></i>
        <i class="fa-solid fa-spinner fa-spin" *ngIf="placingOrder"></i>

        <span *ngIf="!placingOrder">{{ t('placeOrder') }}</span>
        <span *ngIf="placingOrder">{{ t('redirectingToPayment') }}</span>

      </button>

    </div>

    <!-- RIGHT -->

    <div class="summary-card">

      <div class="summary-top">

        <div>

          <p class="summary-mini">
            {{ t('orderDetails') }}
          </p>

          <h2>
            {{ t('orderSummary') }}
          </h2>

        </div>

      </div>

      <!-- ITEMS -->

      <div
        class="summary-item"
        *ngFor="let p of items"
      >

        <div class="summary-left">

        <div class="product-image">

  <img
    [src]="getImage(p.imageUrl)"
    [alt]="p.name"
    onerror="this.src='assets/no-image.png'"
  />

</div>
          <div>

            <h4>
              {{ languageService.productName(p) }}
            </h4>

            <p>
              {{ t('qty') }} &times; {{ p.qty | bnNumber }}
            </p>

          </div>

        </div>

        <strong>
          {{ (p.price * (p.qty || 1)) | bnNumber:'৳ ' }}
        </strong>

      </div>

      <!-- PRICE -->

      <div class="price-box">

        <div class="price-row">

          <span>{{ t('subtotal') }}</span>

          <strong>
            {{ total | bnNumber:'৳ ' }}
          </strong>

        </div>

        <div class="price-row">

          <span>{{ t('delivery') }}</span>

          <strong>
            {{ 60 | bnNumber:'৳ ' }}
          </strong>

        </div>

        <div class="price-row final-row">

          <span>{{ t('total') }}</span>

          <h3>
            &#2547; {{ total + 60 }}
          </h3>

        </div>

      </div>

    </div>

  </div>
  <div class="mobile-checkout-bar">

  <button
    class="checkout-fixed-btn"
    (click)="placeOrder()"
    [disabled]="placingOrder">

    <span *ngIf="!placingOrder">{{ t('checkout') }}</span>
    <span *ngIf="placingOrder">{{ t('redirectingToPayment') }}</span>

    <strong>
      &#2547; {{ total + 60 }}
    </strong>

  </button>

</div>

</div>
